
import { defineComponent, PropType } from 'vue'
import Button from '@/components/btn.vue'
import { useRouter } from 'vue-router'
export interface CardProps {
  _id: string;
  title: string;
  photo: string;
  article: string;
};
export default defineComponent({
  components: {
    Button
  },
  props: {
    card: {
      type: Object as PropType<CardProps>,
      required: true
    }
  },
  setup () {
    const router = useRouter()
    const editPost = (id: string) => {
      router.push(`/update/${id}`)
    }
    return {
      editPost
    }
  }
})
